import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const insightGradient = `linear-gradient(87deg, #e5edff 39.45%, #ffebf1 100%)`;

export const StyledTooltipContent = styled(FlexColumn)`
    min-width: 228px;
    padding: 14px 6px;
    row-gap: 8px;
`;

const IconWrapper = styled.div`
    display: flex;
    margin-right: 8px;

    & .SWReactIcons {
        height: 16px;
        width: 16px;
    }

    svg {
        fill: ${colorsPalettes.carbon[500]};

        path {
            fill: ${colorsPalettes.carbon[500]};
        }
    }
`;

export const StyledIconWrapper = styled(IconWrapper)`
    padding: 4px;
    border-radius: 20px;
    background: ${insightGradient};
`;

export const StyledHeader = styled(FlexRow)`
    align-items: center;
`;

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("report", colorsPalettes.carbon[400])};
`;

export const StyledText = styled.span`
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon[300])};
`;
